import React from "react";
import { Link } from "react-router-dom";

// import qtc2 from "../../img/numeric/qtc/^Qtc.png"
import qtc2 from "../../img/numeric/qtc/^Qtc.png";

import { ImgQtc2 } from "./Qtc2.elements";

export const Qtc2 = () => {
  return (
    <Link to="/settings/changenumeric">
      <ImgQtc2 src={qtc2} />
    </Link>
  );
};
